import MobileSVG from '@assets/illustration/auth/mobile-illustration';
import TabletSVG from '@assets/illustration/auth/tablet-illustration';
import React from 'react';

export const TabletIllustrationDiv = (
  props: React.HTMLProps<HTMLDivElement>,
) => {
  return (
    <div
      {...props}
      className="tablet-illustration -mb-[10px] mt-[10px] max-sm:hidden lg:hidden"
    >
      <TabletSVG className="w-full" />
    </div>
  );
};

export const PhoneIllustrationDiv = (
  props: React.HTMLProps<HTMLDivElement>,
) => {
  return (
    <div
      {...props}
      className="phone-illustration sm:hidden -mb-[9px] max-w-[336px] m-auto mt-[20px] max-[400px]:max-w-[240px] max-[400px]:-mb-[19px] max-[300px]:hidden"
    >
      <MobileSVG className="w-full" />
    </div>
  );
};

export const ContainerForm = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      className="container-form bg-white py-[39px] w-[90%] rounded-2xl lg:min-w-[343px] max-lg:w-full max-lg:py-[40px]"
      {...props}
    >
      {props.children && props.children}
    </div>
  );
};

export const ContainerSelector = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      className="text-left w-[90%] lg:min-w-[343px] max-lg:w-full max-lg:py-[40px] lg:mt-[-70px] lg:ml-[30px]"
      {...props}
    >
      {props.children && props.children}
    </div>
  );
};
